"use strict";
// Copyright © Veeam Software Group GmbH
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useSnapshotsPerHourDialog = void 0;
const react_1 = __importStar(require("react"));
const components_1 = require("@veeam/components");
const index_1 = require("../index");
require("../types");
const useSnapshotsPerHourDialog = () => {
    const [dialog, actions] = components_1.useModal({
        render: ({ deactivate, data }) => {
            if (!data) {
                return null;
            }
            return (react_1.default.createElement(index_1.SnapshotsPerHourDialog, { initialValue: data.initialValue, deactivate: deactivate, onDone: data.onDone, rowName: data.rowName }));
        },
    });
    const show = react_1.useCallback((config) => {
        actions.activate(config);
    }, []);
    const hide = react_1.useCallback(() => {
        actions.deactivate();
    }, []);
    return [dialog, { show, hide }];
};
exports.useSnapshotsPerHourDialog = useSnapshotsPerHourDialog;
//# sourceMappingURL=useSnapshotsPerHourDialog.js.map